@if (navService.showNav$ | async) {
  <app-nav></app-nav>
}

@if (
  (authService.hasUserConsented() | async) === false &&
  (navService.showNav$ | async) &&
  (navService.consentRequired$ | async)
  ) {
  <app-consent-form
    class="overlay"
  ></app-consent-form>
}
<div
  class="app-container"
  [ngClass]="$safeNavigationMigration((navService.routeVisuals$ | async)?.backgroundClass)"
  >
  <main class="main-content" [class.no-nav]="!(navService.showNav$ | async)">
    <router-outlet></router-outlet>
  </main>
  <app-footer></app-footer>
</div>
